import { FETCH_INVOICES, FETCH_INVOICES_SUCCESS, FETCH_INVOICES_ERROR, 
  TOGGLE_INVOICE, TOGGLE_ALL_INVOICES, CHANGE_PAYMENT_AMOUNT, CHANGE_ADHOC_PAYMENT,RESET_PAYMENT_AMOUNT,PAYMENT_TYPE,TOTAL_INVOICE_AMOUNT} from '../action-types/invoice';

const initialState = {
  fetching: false,
  invoicesAndpaymentAmountsBeforeAdhoc: null,
  originalInvoices: [],
  invoices: [],
  paymentAmounts: {},
  adhocPaymentEnabled: false,
  adhocPayment: 0,
  error: '',
  paymentType:'',
  totalInvoiceAmount:0
}

export default (state = initialState, action) => {
  switch(action.type) {
    case FETCH_INVOICES:
      return { ...state, fetching: true};
    case FETCH_INVOICES_SUCCESS:
      let paymentAmounts = {};
      let currencyCode=null;
      action.payload.forEach(invoice => {
        paymentAmounts[invoice.entryNo] = invoice.netAmount; 
      });
      return { ...state, fetching: false, invoices: action.payload, originalInvoices: action.payload, 
        paymentAmounts, error: '', adhocPaymentEnabled: false, adhocPayment: 0, invoicesAndpaymentAmountsBeforeAdhoc: null,currencyCode:action.currencyCode};
    case FETCH_INVOICES_ERROR:
      return { ...state, fetching: false, invoices: [], error: action.payload };
    case TOGGLE_INVOICE:
      return {...state, invoices: state.invoices.map(invoice => {
        if (invoice.entryNo === action.payload) {
          return {...invoice, selected: !invoice.selected}
        }
        return {...invoice} 
      })};
    case TOGGLE_ALL_INVOICES:    
     return {...state, invoices: action.payload.invoices.map(invoice => {               
        return {...invoice, selected: action.payload.checked}
      })};
    case CHANGE_PAYMENT_AMOUNT:
      return {...state, paymentAmounts: {...state.paymentAmounts, [action.payload.entryNo]: (+action.payload.paymentAmount)}}
    case CHANGE_ADHOC_PAYMENT:
      let adhocPaymentEnabled = action.payload.adhocPaymentEnabled;
      let adhocPayment = +action.payload.adhocPayment;
      let invoices = JSON.parse(JSON.stringify(state.originalInvoices));
      let newPaymentAmounts = {};
      let backup = {};
      if (adhocPaymentEnabled && !state.adhocPaymentEnabled) {
        backup = {invoicesAndpaymentAmountsBeforeAdhoc: {invoices: JSON.stringify(state.invoices), paymentAmounts: JSON.stringify(state.paymentAmounts)}}
      }
      if (adhocPaymentEnabled) {
        if (adhocPayment > 0) {
          let balance = adhocPayment;
          invoices.forEach(invoice => {
            if (balance > 0) {
              if (invoice.netAmount > balance) {
                invoice.paymentAmount = balance;
                newPaymentAmounts[invoice.entryNo] = balance;
                balance = 0;
              } else {
                invoice.paymentAmount = invoice.netAmount;
                newPaymentAmounts[invoice.entryNo] = invoice.netAmount;
                balance = balance - invoice.netAmount;
              }
              invoice.selected = true;
            }
          })
        }
        return {...state, adhocPaymentEnabled, adhocPayment, invoices, 
          paymentAmounts: {...state.paymentAmounts, ...newPaymentAmounts},
          ...backup
        }
      }
      return {...state, adhocPaymentEnabled, adhocPayment,
        invoices: JSON.parse(state.invoicesAndpaymentAmountsBeforeAdhoc.invoices),
        paymentAmounts: JSON.parse(state.invoicesAndpaymentAmountsBeforeAdhoc.paymentAmounts)
      }
      case RESET_PAYMENT_AMOUNT:
         let paymentAmt = {};
         action.payload.forEach(invoice => {
          paymentAmt[invoice.entryNo] = invoice.netAmount; 
        });
        return { ...state, paymentAmounts:paymentAmt};
       
        case PAYMENT_TYPE:
        return {...state,paymentType:action.payload }
        case TOTAL_INVOICE_AMOUNT:
        return {...state,totalInvoiceAmount:action.payload}              
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/invoice.js